import { gql } from 'graphql-request';

export default gql`
  query CallDetailRecords(
    $skip: Int
    $take: Int
    $orderBy: JSON
    $filters: JSON
    $mask: String
  ) {
    callDetailRecords(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filters: $filters
      mask: $mask
    ) {
      totalCount
      skip
      take
      callDetailRecords {
        id
        account_id
        doc
        listing
        createdAt
        updatedAt
      }
    }
  }
`;
